import { render, staticRenderFns } from "./richtextweappAttr.vue?vue&type=template&id=07902322&scoped=true"
import script from "./richtextweappAttr.vue?vue&type=script&lang=js"
export * from "./richtextweappAttr.vue?vue&type=script&lang=js"
import style0 from "./richtextweappAttr.vue?vue&type=style&index=0&id=07902322&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07902322",
  null
  
)

component.options.__file = "richtextweappAttr.vue"
export default component.exports